<template>
  <!--====== OFFCANVAS MENU PART START ======-->
  <div>
    <div class="off_canvars_overlay" :class="[sidebar?'active':'']" @click.prevent="hideSidebar">

    </div>
    <div class="offcanvas_menu">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="offcanvas_menu_wrapper" :class="[sidebar?'active':'']">
              <div class="canvas_close">
                <a href="javascript:void(0)" @click="hideSidebar"><i class="fa fa-times"></i></a>
              </div>
              <div class="offcanvas-brand text-center mb-40">
                <!--                                <img src="@/assets/images/logo.png" alt="appie">-->
                <!--                              <span v-html="side"></span>-->
                <!--                              {{side.list}}-->
                <img :src="side.image">
                <p v-html="side.title"></p>
                <p v-html="side.content"></p>
              </div>
              <div id="menu" :style="heightPro" class="text-left ">

                <ul class="offcanvas_main_menu">
                  <li v-for="(item ,index) in side.list" :key="index" class="menu-item-has-children active" :class="[menuOpen ===
                                    item.name?'menu-open':'']">
                    <!--                                      {{item}}-->
                    <!--                                         <span v-if="item.childrens && item.childrens.length > 0 && nasted" class="menu-expand"><i class="fa fa-angle-down"></i></span>-->

                    <!--                                         <router-link style="text-transform: capitalize;" v-if="item.title" :to="item.title"> <span v-html="item.title"></span></router-link>-->

                    <a style="text-transform: capitalize;" v-if="item.title" :to="item.title"
                       @click="ProfileMenuOpen(item.activity,item.url)"><img :src="item.icon" style="width: 30px;"><span
                        v-html="item.title"></span></a>

                    <a v-else href="#" @click.prevent="show(item.title)"> {{ item.title }}</a>
                    <!--                                         <ul v-if="item.childrens && nasted"  :id="item.name" class="sidebar-sub-menu" :class="[menuOpen === item.name?'expend_menu_item':'']">-->
                    <!--                                                <li v-for="(subItem,i) in item.childrens" :key="i">-->
                    <!--                                                    <router-link :to="subItem.path?subItem.path:'#'">{{subItem.name}}</router-link>-->
                    <!--                                                </li>-->
                    <!--                                         </ul>-->
                  </li>
                </ul>
              </div>
              <!--                            <div class="offcanvas-social">-->
              <!--                                <ul class="text-center">-->
              <!--                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>-->
              <!--                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>-->
              <!--                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>-->
              <!--                                    <li><a href="#"><i class="fab fa-dribbble"></i></a></li>-->
              <!--                                </ul>-->
              <!--                            </div>-->
              <!--                            <div class="footer-widget-info">-->
              <!--                                <ul>-->
              <!--                                    <li><a href="#"><i class="fal fa-envelope"></i>Nit</a></li>-->
              <!--                                    <li><a href="#"><i class="fal fa-phone"></i> +(642) 342 762 44</a></li>-->
              <!--                                    <li><a href="#"><i class="fal fa-map-marker-alt"></i> 442 Belle Terre St Floor 7, San Francisco, AV 4206</a></li>-->
              <!--                                </ul>-->
              <!--                            </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--====== OFFCANVAS MENU PART ENDS ======-->
</template>

<script>


import CryptoJS from "crypto-js";

export default {

  props: {

    side: {
      type: Object,
      required: true,
    },
    sidebar: {
      type: Boolean,
      required: true,
    },
    menuItems: {
      type: Array,
      required: true
    },
    nasted: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menuOpen: null,
      subMenuHeight: null,
      navs: []
    }
  },
  computed: {
    heightPro() {
      return {
        '--height': this.subMenuHeight,
      }
    }
  },
  methods: {

    async ProfileMenuOpen(activity, url) {
      alert(activity)
      alert(url)

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;
      if (lastPart === 'Employer_Dynamic_Job_View') {

        const encryptedString = this.encryptUrl(url);
        await this.$router.replace(`/post-view?page=${encodeURIComponent(encryptedString)}`);
      } else if (lastPart === 'ViewCandidate_List') {

        const url = this.urlData;
        const parsedUrl = new URL(url);
        const desiredPath = parsedUrl.pathname.slice(13).replace(/\//g, '-');
        console.log(desiredPath)
        const encryptedString = this.Encrypt(desiredPath);
        const redirectUrl = '/viewed-employer-list?page=' + encryptedString;

        await this.$router.replace(redirectUrl)
      }
    },

    Encrypt(str) {
      // return str.split('').map(char => char.charCodeAt(0)).join('-');
      return str.replace(/[a-zA-Z]/g, function (char) {
        // Replace each alphabetic character with its encrypted value
        const charCode = char.charCodeAt(0);
        const encryptedCharCode = charCode + 1; // You can use a different encryption logic
        return String.fromCharCode(encryptedCharCode);
      });
    },
    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },

    hideSidebar(e) {
      this.$emit("toggleSidebar", e)
    },
    show(value) {
      if (value !== this.menuOpen) {
        this.menuOpen = value
      } else {
        this.menuOpen = null
      }
      const getListItem = document.querySelectorAll(`#${value} li`).length;
      this.subMenuHeight = 43 * getListItem + 'px'
    }
  },

}
</script>

<style>
.sidebar-sub-menu {
  padding-left: 20px;
  overflow: hidden;
  height: 0px
}

.sidebar-sub-menu {
  transition: all linear 0.65s;
}

.sidebar-sub-menu.expend_menu_item {
  transition: all linear 0.65s;
}

.expend_menu_item.sidebar-sub-menu {
  height: var(--height);
}


body {
  background:white!important;
  line-height: 32px;
  //color: #ffffff;
  margin: 0;
  padding: 0;
  word-wrap: break-word !important;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px!important;
}

h1 {
  font-size: 60px;
  text-align: center;
  //color: #FFF;
}

h3 {
  font-size: 30px;
  line-height: 34px;
  text-align: center;
  //color: #FFF;
}

h3 a {
  //color: #FFF;
}

a {
  color: blue !important;
}
div a{
  color: black !important;
}
 a:hover{
   color:black !important;
 }


h1 {
  margin-top: 100px;
  text-align: center;
  font-size: 60px;
  line-height: 70px;
  font-family: 'Bree Serif', 'serif';
}

#container {
  margin: 0 auto;
  max-width: 890px;
}

p {
  text-align: center;
}

.toggle,
[id^=drop] {
  display: none;
}

/* Giving a background-color to the nav container. */
nav {
  margin: 0;
  padding: 0;
  background-color: #254441;
}

#logo {
  display: block;
  padding: 0 30px;
  float: left;
  font-size: 20px;
  line-height: 60px;
}

/* Since we'll have the "ul li" "float:left"
 * we need to add a clear after the container. */

nav:after {
  content: "";
  display: table;
  clear: both;
}

/* Removing padding, margin and "list-style" from the "ul",
 * and adding "position:reltive" */
nav ul {
  float: right;
  padding: 0;
  margin: 0;
  list-style: none;
  position: relative;
}

/* Positioning the navigation items inline */
nav ul li {
  margin: 0px;
  display: inline-block;
  float: left;
  background-color: #254441;
}

/* Styling the links */
nav a {
  display: block;
  padding: 14px 20px;
  //color: #FFF;
  font-size: 17px;
  text-decoration: none;
}


nav ul li ul li:hover {
  background: #000000;
}

/* Background color change on Hover */
nav a:hover {
  background-color: #000000;
}

/* Hide Dropdowns by Default
 * and giving it a position of absolute */
nav ul ul {
  display: none;
  position: absolute;
  /* has to be the same number as the "line-height" of "nav a" */
  top: 60px;
}

/* Display Dropdowns on Hover */
nav ul li:hover > ul {
  display: inherit;
}

/* Fisrt Tier Dropdown */
nav ul ul li {
  width: 170px;
  float: none;
  display: list-item;
  position: relative;
}

/* Second, Third and more Tiers
 * We move the 2nd and 3rd etc tier dropdowns to the left
 * by the amount of the width of the first tier.
*/
nav ul ul ul li {
  position: relative;
  top: -60px;
  /* has to be the same number as the "width" of "nav ul ul li" */
  left: 170px;
}


/* Change ' +' in order to change the Dropdown symbol */
li > a:after {
  content: ' +';
}

li > a:only-child:after {
  content: '';
}


/* Media Queries
--------------------------------------------- */

@media all and (max-width: 768px) {

  #logo {
    display: block;
    padding: 0;
    width: 100%;
    text-align: center;
    float: none;
  }

  nav {
    margin: 0;
  }

  /* Hide the navigation menu by default */
  /* Also hide the  */
  .toggle + a,
  .menu {
    display: none;
  }

  /* Stylinf the toggle lable */
  .toggle {
    display: block;
    background-color: #254441;
    padding: 14px 20px;
    color: #FFF;
    font-size: 17px;
    text-decoration: none;
    border: none;
  }

  .toggle:hover {
    background-color: #000000;
  }

  /* Display Dropdown when clicked on Parent Lable */
[id^=drop]:checked + ul {
  display: block;
}

  /* Change menu item's width to 100% */
  nav ul li {
    display: block;
    width: 100%;
  }

  nav ul ul .toggle,
  nav ul ul a {
    padding: 0 40px;
  }

  nav ul ul ul a {
    padding: 0 80px;
  }

  nav a:hover,
  nav ul ul ul a {
    background-color: #000000;
  }

  nav ul li ul li .toggle,
  nav ul ul a,
  nav ul ul ul a {
    padding: 14px 20px;
    color: #FFF;
    font-size: 17px;
  }


  nav ul li ul li .toggle,
  nav ul ul a {
    background-color: #212121;
  }

  /* Hide Dropdowns by Default */
  nav ul ul {
    float: none;
    position: static;
    color: #ffffff;
    /* has to be the same number as the "line-height" of "nav a" */
  }

  /* Hide menus on hover */
  nav ul ul li:hover > ul,
  nav ul li:hover > ul {
    display: none;
  }

  /* Fisrt Tier Dropdown */
  nav ul ul li {
    display: block;
    width: 100%;
  }

  nav ul ul ul li {
    position: static;
    /* has to be the same number as the "width" of "nav ul ul li" */

  }

}

@media all and (max-width: 330px) {

  nav ul li {
    display: block;
    width: 94%;
  }

}
</style>
